export default __webpack_public_path__ + "static/media/021-winter clothing.ae55ae3b.svg";